import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import ACTIONTYPE_ADDRESS from './Constants';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';

function* getFCCLabelDetails(data) {
  let serviceDetails = null;
  showLoader();
  try {
    const apiResponse = yield call(Actions.getFCCLabelDetailsFromAPI, data);
    const apiPlansResponse = apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse.data;
    if (apiPlansResponse) {
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_SUCCESS, value: apiResponse.data });
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_ERROR, value: false, response: null });
    } else {
      //  need to check error response case
      serviceDetails = {
        method: 'FccLabelContentDetails',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_SUCCESS, value: [] });
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_ERROR, value: true, response: apiPlansResponse, serviceinfo: serviceDetails });
    }
    hideLoader();
  } catch (error) {
    if (error) {
      serviceDetails = {
        method: 'FccLabelContentDetails',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_SUCCESS, value: [] });
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS_ERROR, value: true, response: error, serviceinfo: serviceDetails });
      hideLoader();
    }
  }
}

//  for prepaid API

function* getFccProspectPlans(data) {
  let serviceDetails = null;
  try {
    const apiResponse = yield call(Actions.getFccProspectPlansFromAPI, data.data);
    const apiProspectPlansResponse = apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse.data;
    if (apiProspectPlansResponse) {
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_SUCCESS, value: apiResponse.data });
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_ERROR, value: false, response: null });
    } else {
      serviceDetails = {
        method: 'FccProspectContentDetails',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_SUCCESS, value: [] });
      yield put({
        type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_ERROR,
        value: true,
        response: apiProspectPlansResponse,
        serviceinfo: serviceDetails,
      });
    }
  } catch (error) {
    if (error) {
      serviceDetails = {
        method: 'FccProspectContentDetails',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_SUCCESS, value: [] });
      yield put({ type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS_ERROR, value: true, response: error, serviceinfo: serviceDetails });
    }
  }
}

function* makeRetriveZipcodeCall(data) {
  let serviceDetails = null;
  showLoader();
  try {
    const apiResponse = yield call(Actions.makeRetriveZipcodeCallFromAPI, data?.data);
    const apiPlansResponse = apiResponse && apiResponse.data && !apiResponse.data.errors && apiResponse.data;
    if (apiPlansResponse) {
      yield put({ type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_ERROR, value: false, response: null });
      yield put({ type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_SUCCESS, value: apiResponse.data });
    } else {
      //  need to check error response case
      serviceDetails = {
        method: 'RetrieveMarketzipcode',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_SUCCESS, value: null });
      yield put({
        type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_ERROR,
        value: true,
        response: apiResponse?.data?.errors?.length > 0 ? apiResponse?.data?.errors : 'Please enter a valid zip code',
        serviceinfo: serviceDetails,
      });
    }
    hideLoader();
  } catch (error) {
    if (error) {
      serviceDetails = {
        method: 'RetrieveMarketzipcode',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_SUCCESS, value: null });
      yield put({ type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL_ERROR, value: true, response: error, serviceinfo: serviceDetails });
      hideLoader();
    }
  }
}

function* makeNewBrowsingCall(data) {
  let serviceDetails = null;
  showLoader();
  try {
    const apiResponse = yield call(Actions.makeNewBrowsingCallFromAPI, data?.data);
    const apiPlansResponse = apiResponse && apiResponse?.data && !apiResponse?.data?.errors && apiResponse?.data;
    if (apiPlansResponse) {
      yield put({ type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_SUCCESS, value: apiResponse?.data?.data });
      yield put({ type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_ERROR, value: false, response: null });
    } else {
      //  need to check error response case
      serviceDetails = {
        method: 'NewBrowsingAPICall',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_SUCCESS, value: null });
      yield put({ type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_ERROR, value: true, response: apiPlansResponse, serviceinfo: serviceDetails });
    }
    hideLoader();
  } catch (error) {
    if (error) {
      serviceDetails = {
        method: 'NewBrowsingAPICall',
      };
      yield put({ type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_SUCCESS, value: null });
      yield put({ type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL_ERROR, value: true, response: error, serviceinfo: serviceDetails });
      hideLoader();
    }
  }
}

function* actionWatcher() {
  yield takeLatest(ACTIONTYPE_ADDRESS.GET_FCC_DETAILS, getFCCLabelDetails);
  yield takeLatest(ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS, getFccProspectPlans);
  yield takeLatest(ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL, makeRetriveZipcodeCall);
  yield takeLatest(ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL, makeNewBrowsingCall);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
